window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

casino.repos.casinoPromotionsRepo = function () {

    var list = function (jePromotionPage = null, jeWidget = null, nadimak = null) {

        var baseUrl = 'api/casinopromotions';
        const params = new URLSearchParams();

        if (jeWidget) {
            params.append('jeWidget', 'true');
        }

        if (jePromotionPage) {
            params.append('jePromotionPage', 'true');
        }

        params.append('c', casino.config.guiCacheVerzija);

        if (nadimak && nadimak != 'undefined')
            params.append('nadimak', nadimak);

        const url = `${baseUrl}?${params.toString()}`;

        return fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .catch(error => {
                console.error('There has been a problem with your fetch operation:', error);
            });
    };

    return {
        list: list
    }
}();
